import { LogLevel } from "@azure/msal-browser";

// Always redirect back to whatever origin the app is actually being served
// from, instead of a hardcoded per-domain lookup table. Each real origin
// (localhost:3000, 4dkurser.peoplenet.dk, 4d-kursusinterface.azurewebsites.net, ...)
// still has to be registered as a redirect URI on the AAD app registration
// (ClientId 6047cbe0-ebea-4862-b58c-ab20bf477886, tenant 4d.dk) or login will
// fail with AADSTS50011.
const redirectUrl = `${window.location.origin}/`;

export const msalConfig = {
    auth: {
        clientId: "6047cbe0-ebea-4862-b58c-ab20bf477886",
        authority: "https://login.microsoftonline.com/2a87cbf1-9133-479e-bd3a-fa4e7cd85065",
        redirectUri: redirectUrl,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level: any, message: string, containsPii: boolean) => {	
                if (containsPii) {		
                    return;		
                }		

                switch (level) {		
                    case LogLevel.Error:	
                        console.error(message);			
                        return;		
                    case LogLevel.Info:		
                        console.info(message);	
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

export const loginRequest = {
    scopes: ["api://6047cbe0-ebea-4862-b58c-ab20bf477886/user_impersonation"],
};
